import { useEffect, useRef, useState } from 'react';
import { Button, ButtonSizes, ButtonStyles, Icon, Icons, ListItem, Search } from '@silverfort/sf-components';

const HostnameSelector = ({ results, onSearch, onSelect, selectHostnames, onClose, isOpen }) => {
    const [open, setOpen] = useState(false);
    const menuRef = useRef(null);
    const searchRef = useRef(null);

    const closeMenu = (e) => {
        if (open && !menuRef.current?.contains(e?.target)) {
            setOpen(false);
            onClose();
        }
    };

    const handleSearch = (text) => {
        onSearch(text);
    };

    useEffect(() => {
        document.addEventListener('click', closeMenu);
        return () => document.removeEventListener('click', closeMenu);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    useEffect(() => {
        setOpen(isOpen);
        searchRef.current?.focus();
    }, [isOpen]);

    return (
        <div className="relative origin-top-right">
            <Button
                buttonStyle={ButtonStyles.Primary}
                buttonSize={ButtonSizes.Small}
                text="Add"
                iconLeft={Icons.Add}
                onClick={(e) => {
                    e.preventDefault();
                    if (!open) {
                        setOpen(true);
                    } else {
                        closeMenu(e);
                    }
                }}
            />
            {open && (
                <div
                    ref={menuRef}
                    className="absolute z-20 mt-2 rounded-lg bg-white pt-2 shadow-sf-medium w-[320px] origin-top-left right-0">
                    <div className="flex items-center w-full border-b h-10 px-2">
                        <Search
                            inputRef={searchRef}
                            onChange={handleSearch}
                            placeholder="Search Hostname"
                            className="w-full h-10"
                        />
                    </div>

                    {results.length === 0 ? (
                        <div className="h-14 flex justify-center items-center">
                            <span className="text-12 font-normal text-sf-gray-500"> No result</span>
                        </div>
                    ) : (
                        <div className="p-2">
                            {results.map((result, index) => {
                                const isSelected = selectHostnames.includes(result.name);

                                return (
                                    <div
                                        key={index}
                                        className="flex items-center px-2 rounded-lg justify-between hover:bg-sf-gray-50">
                                        <ListItem
                                            disabled={isSelected}
                                            title={result.name}
                                            IconLeft={() => <Icon icon={Icons.Server} />}
                                            subtitle="Host"
                                            onClick={() => !isSelected && onSelect(result.name)}
                                        />

                                        {isSelected && (
                                            <div className="flex w-fit items-center h-6 bg-sf-gray-100 px-2 text-12 font-medium text-sf-gray-500 rounded">
                                                Added
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default HostnameSelector;
